import { createReducer } from '@reduxjs/toolkit';
import { clearAlertInfoAction, hideAlertInfoAction, showAlertInfoAction } from '@redux/alert/alertActions';
import { AlertState } from './alertTypes';

export const initialAlertState: AlertState = {
  isAlertVisible: false,
  config: {
    title: '',
    message: '',
    vertical: 'top',
    horizontal: 'right',
    iconSrc: ''
  }
};

export default createReducer(initialAlertState, (builder) => {
  builder
    .addCase(showAlertInfoAction, (state, action) => {
      state.isAlertVisible = true;
      state.config = { ...action.payload };
    })
    .addCase(hideAlertInfoAction, (state) => {
      state.isAlertVisible = false;
    })
    .addCase(clearAlertInfoAction, (state) => {
      state.config = { ...initialAlertState.config };
    });
});
